import { IWPImage, IWPLink } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";

export type IHeaderData = {
  wp: {
    siteSettings: {
      siteSettings: {
        header: {
          ctaLinks: {
            ctaLink: IWPLink;
          }[];
          logo: IWPImage;
          showCtaBlock: string;
          ctaSubMenu: {
            ctaLink: IWPLink;
            ctaText: string;
          };
          aboutSdf: {
            intressepolitikSubMenu: {
              subLink: IWPLink;
              subSubLinks: {
                subSubLink: IWPLink;
              }[];
            };
            backgroundColor: string;
            navbarLink: IWPLink;
            showSubLinks: string;
            subLinks: {
              subLink: IWPLink;
              subSubLinks: {
                subSubLink: IWPLink;
              }[];
            }[];
          };
          verksamhet: {
            backgroundColor: string;
            navbarLink: IWPLink;
            showSubLinks: string;
            subLinks: {
              subLink: IWPLink;
              subSubLinks: {
                subSubLink: IWPLink;
              }[];
            }[];
          };
          radOchStod: {
            backgroundColor: string;
            navbarLink: IWPLink;
            showSubLinks: string;
            subLinks: {
              subLink: IWPLink;
              subSubLinks: {
                subSubLink: IWPLink;
              }[];
            }[];
          };

          aboutDeafAndSignLanguage: {
            backgroundColor: string;
            navbarLink: IWPLink;
            showSubLinks: string;
            subLinks: {
              subLink: IWPLink;
              subSubLinks: {
                subSubLink: IWPLink;
              }[];
            }[];
          };
        };
      };
    };
  };
};

const useHeaderData = () => {
  const { wp }: IHeaderData = useStaticQuery(graphql`
    {
      wp {
        siteSettings {
          siteSettings {
            header {
              showCtaBlock
              ctaSubMenu {
                ctaLink {
                  target
                  title
                  url
                }
                ctaText
              }
              ctaLinks {
                ctaLink {
                  target
                  title
                  url
                }
              }
              logo {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      placeholder: BLURRED
                      formats: [AUTO, WEBP]
                      width: 240
                    )
                  }
                }
              }
              aboutSdf {
                intressepolitikSubMenu {
                  subLink {
                    target
                    title
                    url
                  }
                  subSubLinks {
                    subSubLink {
                      target
                      title
                      url
                    }
                  }
                }

                backgroundColor
                navbarLink {
                  target
                  title
                  url
                }
                showSubLinks
                subLinks {
                  subLink {
                    target
                    title
                    url
                  }
                  subSubLinks {
                    subSubLink {
                      target
                      title
                      url
                    }
                  }
                }
              }
              verksamhet {
                backgroundColor
                navbarLink {
                  target
                  title
                  url
                }
                showSubLinks
                subLinks {
                  subLink {
                    target
                    title
                    url
                  }
                  subSubLinks {
                    subSubLink {
                      target
                      title
                      url
                    }
                  }
                }
              }
              radOchStod {
                backgroundColor
                navbarLink {
                  target
                  title
                  url
                }
                showSubLinks
                subLinks {
                  subLink {
                    target
                    title
                    url
                  }
                  subSubLinks {
                    subSubLink {
                      target
                      title
                      url
                    }
                  }
                }
              }
              aboutDeafAndSignLanguage {
                backgroundColor
                navbarLink {
                  target
                  title
                  url
                }
                showSubLinks
                subLinks {
                  subLink {
                    target
                    title
                    url
                  }
                  subSubLinks {
                    subSubLink {
                      target
                      title
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  return wp.siteSettings.siteSettings.header;
};
export default useHeaderData;
